import React from 'react';

/**
 * PageHeader - Çok kompakt ve minimal tasarım
 */
const PageHeader = ({ icon: Icon, title, subtitle, children }) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-md p-2 sm:p-3 mb-3">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2">
          {Icon && (
            <div className="p-1.5 rounded-lg bg-white/20 backdrop-blur-sm">
              <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            </div>
          )}
          <div>
            <h1 className="text-base sm:text-lg font-bold tracking-tight">{title}</h1>
            {subtitle && <p className="text-[10px] sm:text-xs text-white/90 mt-0">{subtitle}</p>}
          </div>
        </div>
        {children && <div className="flex gap-2 flex-wrap w-full sm:w-auto">{children}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
